<template>
  <div class="lxm-dashboard-guide">
    <img class="lxm-dashboard-guide__bell"
         src="../../../images/main/bell.png" />
    <div class="lxm-dashboard-guide__title">
      还没有新鲜事哦，快去电脑端灵析发起筹款吧！
    </div>
    <!-- @todo 临时关闭灵析星期四 -->
    <!--<div class="lxm-dashboard-guide__hr">-->
      <!--<div></div>-->
      <!--<div></div>-->
      <!--<div></div>-->
      <!--<div></div>-->
      <!--<div></div>-->
    <!--</div>-->
    <!--<div class="lxm-dashboard-guide__sub">-->
      <!--不会用灵析？-->
    <!--</div>-->

    <!--<a target="_blank" href="http://lxi.me/9nlie">-->
      <!--<div class="lxm-dashboard-guide__button">-->
        <!--点击这里,免费参加线上演示培训-->
      <!--</div>-->
    <!--</a>-->
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../../styles/index.styl'
  .lxm-dashboard-guide
    text-align: center
    color: grey-darker
  .lxm-dashboard-guide__bell
    width: siz(218 / 4)
    height: siz(274 / 4)
    margin-top: siz(25)
  .lxm-dashboard-guide__title
    font-size: siz(16)
    margin-top: siz(19)
  .lxm-dashboard-guide__hr
    font-size: 0
    margin: siz(43 / 2) auto siz(52 / 2)
    div
      display: inline-block
      width: siz(6)
      height: siz(1)
      background-color: #c1c1c1
      margin-right: siz(4)
      :last-child
        margin-right: 0
  .lxm-dashboard-guide__sub
    font-size: siz(13)
  .lxm-dashboard-guide__button
    font-size: siz(13)
    color: white
    background-color: brand-primary
    width: siz(430 / 2)
    height: siz(80 / 2)
    line-height: siz(80 / 2)
    border-radius: siz(80 / 4)
    margin: siz(10) auto 0
</style>

<script>
  export default {
    components: {
    },
    computed: {

    }
  }
</script>



// WEBPACK FOOTER //
// Guide.vue?8ec44194